import {
  fevorvertragsnummer,
  loadAndMigrateState,
  Migrator,
  migrateExtremwetterschutz,
  migrateProduktForVorteilsrabatt,
  migrateProduktnameToEnum,
  migrateZahlungsoptionen,
} from '@ps20-frontend/migrations';
import { IAppState } from '../appState';
import { migrateAssekuranztarif } from './5_migrate_assekuranztarif';
import { migrateSelbstbeteiligung } from './6_migrate_selbstbeteiligung';
import { migrateProduktnameToEnumVersSummen } from './9_migrate_versSummen';
import { migrateProduktnameToEnumSelectedWertsachensumme } from './10_migrate_selectedWertsachensumme';
import { migrateKooperationsNachlass } from './12_migrate_kooperations_nachlass';
import { migrateElementarVorschaeden } from './16_migrate_elementar_vorschaeden';
import { migrateElementarVorschadenErsatzgeschaeft } from './17_migrate_elementar_vorschaden_ersatzgeschaeft';

export const stateMigrators: Migrator[] = [
  {
    toVersion: 4,
    migratorFunction: fevorvertragsnummer,
  },
  {
    toVersion: 5,
    migratorFunction: migrateAssekuranztarif,
  },
  {
    toVersion: 6,
    migratorFunction: migrateSelbstbeteiligung,
  },
  {
    toVersion: 7,
    migratorFunction: migrateZahlungsoptionen,
  },
  {
    toVersion: 8,
    migratorFunction: migrateProduktnameToEnum,
  },
  {
    toVersion: 9,
    migratorFunction: migrateProduktnameToEnumVersSummen,
  },
  {
    toVersion: 10,
    migratorFunction: migrateProduktnameToEnumSelectedWertsachensumme,
  },
  {
    toVersion: 11,
    migratorFunction: migrateExtremwetterschutz,
  },
  {
    toVersion: 12,
    migratorFunction: migrateKooperationsNachlass,
  },
  {
    toVersion: 13,
    migratorFunction: migrateProduktForVorteilsrabatt,
  },
  {
    toVersion: 14,
    migratorFunction: migrateProduktForVorteilsrabatt,
  },
  {
    toVersion: 15,
    migratorFunction: migrateProduktForVorteilsrabatt,
  },
  {
    toVersion: 16,
    migratorFunction: migrateElementarVorschaeden,
  },
  {
    toVersion: 17,
    migratorFunction: migrateElementarVorschadenErsatzgeschaeft,
  },
];

export const loadAndMigrateVhvState = (
  currentState: IAppState,
  loadedState: { version: number },
  beibehalten?: boolean,
) => loadAndMigrateState(currentState, loadedState, stateMigrators, beibehalten);
